<template>
    <v-lazy><div class="section fade-in grey-card">
      <v-container class="px-10" fluid>
      <v-row justify="center">
          <v-col xl="5" lg="6" md="6" cols="12">
          <v-img
          src="../assets/img/customer-portal.png"
          class="mx-auto"
          max-width="400"
          contain/>
        </v-col>
        <v-col xl="5" lg="6" md="6" cols="12">
          <h2 class="section__header-title mb-15">Customer Portals</h2>
              <v-row>
                  <v-col>
                      <v-card class="mb-8 fill-height">
                          <v-card-title>Configurable workflows</v-card-title>
                          <v-card-text>Enable different treatments for different segments of customers, including hardship processes.</v-card-text>
                      </v-card>
                  </v-col>
                  <v-col>
                      <v-card class="mb-8 fill-height">
                          <v-card-title>Notifications</v-card-title>
                          <v-card-text>Provide notifications for due payments, loan updates and new offers.</v-card-text>
                      </v-card>
                  </v-col>
              </v-row>
              <v-row>
                  <v-col>
                      <v-card class="mb-8 fill-height">
                          <v-card-title>Dynamic Experiences</v-card-title>
                          <v-card-text>Provide unique experiences for different customer segments.
                              </v-card-text>
                      </v-card>
                  </v-col>
                  <v-col>
                      <v-card class="mb-8 fill-height">
                          <v-card-title>Account Management</v-card-title>
                          <v-card-text>Allow customers to manage their accounts, view balances and make payments.</v-card-text>
                      </v-card>
                  </v-col>
              </v-row>
              
              <!-- <div class="mb-10">
                  <h3>White-Labelled</h3>
                  Create an on-brand experience for your customers - no styling required or custom development required.
              </div>
              <div class="mb-10">
                  <h3>Personalised Offers</h3>
                  Showcase personalised offers based on customer's profile and history.
              </div>
              <div class="mb-10">
                  <h3>Payment Plans</h3>
                  Allow customers to set up payment plans or instance payment processing based on your negotiation boundaries.
              </div>
              <div class="mb-10">
                  <h3>Payment Processing</h3>
                  Can be integrated with any payment gateway.
              </div> -->
        </v-col>
      </v-row>
    </v-container>
  </div></v-lazy>
</template>
<script>
export default {
    name: 'CollectionsEngagement',
}
</script>

<style lang="scss">

.timeline-container {
  position: relative; 
  height: 10em;
}
.timeline-content {
  height: 100%; 
  align-items: center;
}

.under-img {
  position: absolute;
  left: 7em;
  top: 0;
  z-index: -1;
}

</style>